import Vue from 'vue'
import Router from 'vue-router'


const index =  resolve => require(['@/page/index'], resolve);
const doubleTwelve =  resolve => require(['@/page/doubleTwelve'], resolve);
const myPrize = resolve => require(['@/page/myprize'],resolve);
const inputAddress = resolve => require(['@/page/inputAddress'],resolve);
const inputAddressNew = resolve => require(['@/page/inputAddressNew'],resolve);
const rule = resolve => require(['@/page/rule'],resolve);
const queryPage = resolve => require(['@/page/queryPage'],resolve);

const doubleTwelvePc = resolve => require(['@/page/doubleTwelvePc'], resolve);

const fissionActivity = resolve => require(['@/page/fissionActivity'], resolve);
const assistUser = resolve => require(['@/page/fissionActivity/assistUser'], resolve);
const assistPage = resolve => require(['@/page/fissionActivity/assist'], resolve);

const winterHoliday = resolve => require(['@/page/winterHoliday'], resolve);

const limitedTimeTask = resolve => require(['@/page/limitedTimeTask'], resolve);
const limitedTimeTaskPrizeList = resolve => require(['@/page/limitedTimeTask/mylottery'], resolve);

const laborDayActivity = resolve => require(['@/page/laborDayActivity'], resolve);
const duanWuActivity = resolve => require(['@/page/duanWuActivity'], resolve);
// 湖南移动玩游戏送流量
const hunanPlayGames = resolve => require(['@/page/hunanPlayGames'], resolve);

//子路由模块
import anniversary2021 from './anniversary2021'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: '/miguplay/html/marketing',
  routes: [
    {
      path: '/',
      name: 'index',
      component: index,
      meta:{
        keepAlive:true
      }
    },
    {
      path: '/double12',
      name: 'doubleTwelve',
      component: doubleTwelve,
      meta:{
        keepAlive:true
      }
    },
    {
      path: '/myPrize',
      name: 'myPrize',
      component: myPrize
    },
    {
      path: '/address/:addtype',// addtype传1
      name: 'inputAddress',
      component: inputAddress
    },
    {
      path: '/addressNew/:addtype',// 2021/7/13 因为业木林增加了新的填写和查询地址接口,为了不影响现网其他活动所以新建一个收货地址页面, 等以后确定老的不用了再迁移
      name: 'inputAddressNew',
      component: inputAddressNew
    },
    {
      path: '/rule',
      name: 'rule',
      component: rule
    },
    {
      path: '/queryPage',
      name: 'queryPage',
      component: queryPage
    },
    {
      // 双十二PC活动
      path: '/pc/double12Pc',
      name: 'doubleTwelvePc',
      component: doubleTwelvePc,
      meta:{
        keepAlive:true
      }
    },
    {
      // 裂变助力活动
      path: '/fissionActivity',
      name: 'fissionActivity',
      component: fissionActivity,
    },
    {
      // 裂变助力好友列表
      path: '/fissionActivity/assistUser',
      name: 'assistUser',
      component: assistUser,
    },
    {
      // 裂变助力好友助力页面
      path: '/fissionActivity/assist',
      name: 'assistPage',
      component: assistPage,
    },
    {
      // 暖冬活动
      path: '/mildWinter/index',
      name: 'mildWinter',
      component: () => import('@/page/mildWinter/index'),
      meta:{
        keepAlive:true,
        isBack: false, //用于判断上一个页面是哪个
      }
    },
    {
      // 暖冬活动-我的奖品
      path: '/mildWinter/myPrize',
      name: 'mildWinter',
      component: () => import('@/components/mildwinter/myPrize'),
    },
    {
      // 暖冬活动-填写地址
      path: '/mildWinter/address/:addtype',
      name: 'mildWinter',
      component: () => import('@/components/mildwinter/inputAddress'),
    },
    {
      // 暖冬活动-活动规则
      path: '/mildWinter/rule',
      name: 'mildWinter',
      component: () => import('@/components/mildwinter/rule'),
    },
    {
      // 暖冬活动-
      path: '/mildWinter/queryPage',
      name: 'mildWinter',
      component: () => import('@/components/mildwinter/queryPage'),
    },
    {
      // 寒假活动
      path: '/winterHoliday',
      name: 'winterHoliday',
      component: winterHoliday,
      // children: [{

      // }],
    },
    {
      // 版权游戏限时任务
      path: '/limitedTimeTask',
      name: 'limitedTimeTask',
      component: limitedTimeTask,    
    },
    {
      // 版权游戏限时任务奖品
      path: '/limitedTimeTask/mylottery',
      name: 'limitedTimeTaskmylottery',
      component: limitedTimeTaskPrizeList,    
    },
    
    {
      // 五一狂欢
      path: '/laborDayActivity',
      name: 'laborDayActivity',
      component: laborDayActivity,
    },
    {
      // 端午活动
      path: '/duanWuActivity',
      name: 'duanWuActivity',
      component: duanWuActivity,
    },

    //子活动
    ...anniversary2021,
    {
      // 湖南移动玩游戏送流量
      path: '/hunanPlayGames',
      name: 'hunanPlayGames',
      component: hunanPlayGames,
    },
    {
      // 东奥活动
      path: '/snowtogether',
      name: 'snowtogether',
      component: () => import('@/page/tokyoOlympic'),
    },
    {
      // 挑刺活动
      path: '/pickFault',
      name: 'pickFault',
      component: () => import('@/page/pickFault'),
    },
    {
      // 挑刺能手：意见列表
      path: '/pickFault/opinionList',
      name: 'opinionList',
      component: () => import('@/page/pickFault/opinionList'),
    },
    {
      //挑刺活动荣耀榜
      path: '/pickFault/rankList',
      name: 'rankList',
      component: () => import('@/page/pickFault/rankList'),

    }

  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      if (from.meta.keepAlive) {
      　　from.meta.savedPosition = document.body.scrollTop;
      }
      return { x: 0, y: to.meta.savedPosition ||0}
    }
    
  }
  
})



// WEBPACK FOOTER //
// ./src/router/index.js